import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarPlanningsApi } from "../../http/carPlannings/api";
import { CarPlanning } from "../../http/carPlannings/types";
import ModalDialog from "../ui/ModalDialog";

interface DeleteCarPlanningDialogProps {
  carPlanning: CarPlanning;
  onClose: () => void;
}

const DeleteCarPlanningDialog: FC<DeleteCarPlanningDialogProps> = ({ carPlanning, onClose }) => {
  const i18n = useI18n();
  const carPlanningApi = useCarPlanningsApi();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useContext(NotificationDispatch);

  return (
    <ModalDialog
      onClose={onClose}
      isSubmitting={isSubmitting}
      title={i18n.t.carPlannings.delete}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            carPlanningApi
              .deleteAdminCarPlanning(carPlanning)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.carPlannings.questions.delete}
    </ModalDialog>
  );
};

export default DeleteCarPlanningDialog;
